import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Footer from "./components/footer/Footer";
import axios from "axios";
import { Hero } from "./components/Hero";
import { Banner } from "./components/Banner";
import { CustomTabs } from "./components/tabs/CustomTabs";
import LayoutContainer from "./components/containers/LayoutContainer";
import CardContainer from "./components/containers/CardContainer";
import RansomwareSection from "./components/RansomwareSection";
import CybercrimeSection from "./components/CybercrimeSection";
import moment from "moment";

const ransomwareQueryParams = (
  sectorFilter,
  groupFilter,
  dateFilter,
  countrieFilter
) => {
  let query = "?";
  if (countrieFilter?.value) query += `country=${countrieFilter?.value}&`;
  if (sectorFilter?.value) query += `sector=${sectorFilter?.value}&`;
  if (groupFilter?.value) query += `group=${groupFilter?.value}&`;
  const formattedFromDate = dateFilter?.from_date
    ? dateFilter?.from_date.toISOString().split("T")[0]
    : null;
  const formattedToDate = dateFilter?.to_date
    ? dateFilter?.to_date.toISOString().split("T")[0]
    : null;
  if (formattedFromDate) query += `from_date=${formattedFromDate}&`;
  if (formattedToDate) query += `to_date=${formattedToDate}`;
  return query;
};

const colors = [
  "#2E00FF",
  "#FFAE00",
  "#AA8639",
  "#FF0081",
  "#FF6F00",
  "#01FF00",
  "#804060",
];

const dateOptions = [
  { value: "all_time", label: "All Time" },
  {
    value: "this_week",
    label: "This Week",
    dates: {
      from_date: moment().startOf("week").toDate(),
      to_date: moment().endOf("week").toDate(),
    },
  },
  {
    value: "last_week",
    label: "Last Week",
    dates: {
      from_date: moment().subtract(1, "weeks").startOf("week").toDate(),
      to_date: moment().subtract(1, "weeks").endOf("week").toDate(),
    },
  },
  {
    value: "this_month",
    label: "This Month",
    dates: {
      from_date: moment().startOf("month").toDate(),
      to_date: moment().endOf("month").toDate(),
    },
  },
  {
    value: "last_month",
    label: "Last Month",
    dates: {
      from_date: moment().subtract(1, "months").startOf("month").toDate(),
      to_date: moment().subtract(1, "months").endOf("month").toDate(),
    },
  },
  {
    value: "this_year",
    label: "This Year",
    dates: {
      from_date: moment().startOf("year").toDate(),
      to_date: moment().endOf("year").toDate(),
    },
  },
  {
    value: "last_year",
    label: "Last Year",
    dates: {
      from_date: moment().subtract(1, "years").startOf("year").toDate(),
      to_date: moment().subtract(1, "years").endOf("year").toDate(),
    },
  },
];

function App() {
  const [activeKey, setActiveKey] = useState("ransomware");
  const [ransomwareDates, setRansomwareDates] = useState("2020-01-12T00:00:00");
  const [topSectors, setTopSectors] = useState([]);
  const [topGroupNames, setTopGroupNames] = useState([]);
  const [messagesOverTime, setMessagesOverTime] = useState([]);
  const [messageTypes, setMessageTypes] = useState([]);
  const [messageTypeColors, setMessageTypeColors] = useState({});
  const [countries, setCountries] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [groups, setGroups] = useState([]);
  const [countrieFilter, setCountrieFilter] = useState(null);
  const [sectorFilter, setSectorFilter] = useState(null);
  const [groupFilter, setGroupFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (option) => {
    setSelectedOption(option);
    if (option.value === "all_time") {
      setDateFilter(null);
    } else {
      setDateFilter(option.dates);
    }
  };

  const [queryParam, setQueryParam] = useState(
    ransomwareQueryParams(sectorFilter, groupFilter, dateFilter, countrieFilter)
  );

  useEffect(() => {
    setQueryParam(
      ransomwareQueryParams(
        sectorFilter,
        groupFilter,
        dateFilter,
        countrieFilter
      )
    );
  }, [
    sectorFilter?.value,
    groupFilter?.value,
    selectedOption?.value,
    countrieFilter?.value,
  ]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/countries`, {
        headers: {
          apikey: process.env.REACT_APP_EAS_API_KEY,
          "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
        },
      })
      .then((response) => {
        setCountries(response.data);
      });

    axios
      .get(`${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/sectors`, {
        headers: {
          apikey: process.env.REACT_APP_EAS_API_KEY,
          "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
        },
      })
      .then((response) => {
        setSectors(response.data);
      });

    axios
      .get(`${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/groups`, {
        headers: {
          apikey: process.env.REACT_APP_EAS_API_KEY,
          "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
        },
      })
      .then((response) => {
        setGroups(response.data);
      });

    axios
      .get(
        `${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/top-sectors${queryParam}`,
        {
          headers: {
            apikey: process.env.REACT_APP_EAS_API_KEY,
            "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
          },
        }
      )
      .then((response) => {
        setTopSectors(response.data);
      });

    axios
      .get(
        `${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/top-group-names${queryParam}`,
        {
          headers: {
            apikey: process.env.REACT_APP_EAS_API_KEY,
            "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
          },
        }
      )
      .then((response) => {
        setTopGroupNames(response.data);
      });

    axios
      .get(`${process.env.REACT_APP_EAS_BASE_URL}/api/ransomware/dates`, {
        headers: {
          apikey: process.env.REACT_APP_EAS_API_KEY,
          "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
        },
      })
      .then((response) => {
        if (response?.data?.earliest_date)
          setRansomwareDates(response?.data?.earliest_date);
      });

    //`${process.env.REACT_APP_EAS_BASE_URL}/api/messages/overtime`,
    axios
      .get(
        `${process.env.REACT_APP_EAS_BASE_URL}/api/messages/overtime/hourly`,
        {
          headers: {
            apikey: process.env.REACT_APP_EAS_API_KEY,
            "X-CloudManager-Id": process.env.REACT_APP_EAS_CLOUD_ID,
          },
        }
      )
      .then((response) => {
        const rawData = response.data.map((item) => ({
          ...item,
          message_type:
            item.message_type === "undefined"
              ? "Others"
              : item.message_type === null
              ? "Infostealers"
              : item.message_type,
        }));
        // const transformedData = transformData(rawData);
        const transformedData = transformDataHourly(rawData);
        setMessagesOverTime(transformedData);

        const types = new Set();
        rawData.forEach(({ message_type }) => types.add(message_type));

        const typesArray = Array.from(types);
        const colorsMapping = {};
        typesArray.forEach((type, index) => {
          colorsMapping[type] = colors[index % colors.length];
        });

        setMessageTypes(typesArray);
        setMessageTypeColors(colorsMapping);
      })
      .catch((error) => console.error("Error fetching data: ", error));
  }, [queryParam]);

  useEffect(() => {
    setCountrieFilter(null);
    setSectorFilter(null);
    setGroupFilter(null);
    setDateFilter(null);
    setSelectedOption(null);
  }, [activeKey]);

  return (
    <div>
      <Hero />
      <LayoutContainer>
        <CustomTabs activeKey={activeKey} setActiveKey={setActiveKey} />
        <CardContainer>
          {activeKey === "ransomware" ? (
            <RansomwareSection
              ransomwareDates={ransomwareDates}
              topGroupNames={topGroupNames}
              topSectors={topSectors}
              countrieFilter={countrieFilter}
              setCountrieFilter={setCountrieFilter}
              sectorFilter={sectorFilter}
              setSectorFilter={setSectorFilter}
              groupFilter={groupFilter}
              setGroupFilter={setGroupFilter}
              countries={countries}
              sectors={sectors}
              groups={groups}
              dateOptions={dateOptions}
              selectedOption={selectedOption}
              handleChange={handleChange}
              queryParam={queryParam}
            />
          ) : (
            <CybercrimeSection
              messagesOverTime={messagesOverTime}
              messageTypes={messageTypes}
              messageTypeColors={messageTypeColors}
            />
          )}
        </CardContainer>
      </LayoutContainer>
      <Banner />
      <Footer />
    </div>
  );
}

export default App;

function transformData(rawData) {
  const transformed = [];

  rawData.forEach(({ month, message_type, message_count }) => {
    let entry = transformed.find((entry) => entry.month === month);
    if (!entry) {
      entry = { month };
      transformed.push(entry);
    }
    entry[message_type] = message_count;
  });

  return transformed;
}

function transformDataHourly(rawData) {
  const transformed = [];

  rawData.forEach(({ hour, message_type, message_count }) => {
    let entry = transformed.find((entry) => entry.hour === hour);
    if (!entry) {
      entry = { hour };
      transformed.push(entry);
    }
    entry[message_type] = message_count;
  });

  return transformed;
}
